import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, Output, EventEmitter, PipeTransform, AfterViewInit, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { merge, fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith, tap, delay } from 'rxjs/operators';

import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, } from '@angular/material/snack-bar';
import { PurchasingService } from '../../services/purchasing.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';

import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Location } from '@angular/common'

import * as _ from 'underscore';
import * as XLSX from 'xlsx';
declare let $: any;


@Component({
	selector: 'app-open-rgas',
	templateUrl: './open-rgas.component.html',
	styleUrls: ['./open-rgas.component.scss']
})
export class OpenRgasComponent implements OnInit, OnChanges {

	@Input() item: any = false;
	@Input() vendor: any = false;
	@Output() update_item = new EventEmitter < any > ();
	@Output() orderloaded = new EventEmitter < any > ();
	@Output() po_data = new EventEmitter < any > ();
	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;

	purchaseorders: any = [];
	allpurchaseorders: any = [];


	headercolumns: string[] = [
		'actions',
		'orderno',
		'status_id',
		'suppname',
		'orddate',
		'requisitionno',
		'ordervalue',
		'orderpendingvalue',
		'ordereditems',
		'deliverydate',
		'initiator',

	];

	statuses: any = [];
	openOrderData: any = [];
	config: any = [];
	baselink = '';
	reclink = '';
	color = '';
	podetails: any = [];
	vendorSearch = new FormControl('');
	status= new FormControl('');
	searching = false
	search: any = false;

	constructor(private route: ActivatedRoute, private purchasingService: PurchasingService, private globalsService: GlobalsService, public globalSearchService: GlobalSearchService, public location: Location, private modalService: NgbModal) {

		this.color = this.globalSearchService.getColor();

	}

	ngOnInit(): void {
		this.config = this.globalsService.getApiConfig()
		this.baselink = this.config.apiServer.poLink;
		this.reclink = this.config.apiServer.recLink;
	}

	loadData() {
		this.purchasingService.searchRgas(this.search).subscribe((results: any) => {
			this.allpurchaseorders = results;
			this.po_data.emit(results);
			this.statuses = results.statuses
			this.setTableData(results.pos)
		});
	}

	getStatus(id: any) {
		return this.statuses.filter((st) => {
			return parseFloat(st.status_id) == parseFloat(id)
		})[0];
	}

	setTableData(data: any) {
		this.openOrderData = data;

		this.purchaseorders = new MatTableDataSource(data);
		this.purchaseorders.sort = this.sort;
		this.purchaseorders.paginator = this.paginator;
	}

	loadOrder(orderno: any) {
		this.purchasingService.loadRga(orderno).subscribe((result: any) => {
			this.orderloaded.emit(result);
		});
	}


	searchOrders() {
		const search = {
			status: this.status.value,
			keywords: this.vendorSearch.value,
			vendor: this.vendor
		}
		this.purchasingService.searchRgas(search).subscribe((results: any) => {
			this.allpurchaseorders = results;
			this.po_data.emit(results);
			this.statuses = results.statuses
			this.setTableData(results.pos)
		});
	}

	updateStatus(event: any, trans: any) {

		const status_details = this.getStatus(event.value);
		const index = this.allpurchaseorders.pos.indexOf(trans)

		this.allpurchaseorders.pos[index].editing = false;
		this.allpurchaseorders.pos[index].status_id = status_details.status_id;
		this.allpurchaseorders.pos[index].statusname = status_details.name;

		this.purchasingService.updateRgaStatus(this.allpurchaseorders.pos[index]).subscribe((result: any) => {
			if(this.vendor?.supplierid){
				result.pos = result.pos.filter((o) => o.supplierno == this.vendor.supplierid);
			}
			this.allpurchaseorders = result;
			this.po_data.emit(result);
			this.statuses = result.statuses
			this.setTableData(result.pos)
		})

	}

	exportExcel() {
		this.globalSearchService.exportJsonToExcel(this.allpurchaseorders.pos, 'OpenPurchaseOrders');
	}

	toggleStatusChange(trans: any) {
		const index = this.allpurchaseorders.pos.indexOf(trans);
		if (this.allpurchaseorders.pos[index].editing) {
			this.allpurchaseorders.pos[index].editing = false;
		} else {
			this.allpurchaseorders.pos[index].editing = true;
		}
	}

	onInput() {
		//tood make this ajax call to search for items on orders as well
		const search = this.vendorSearch.value;
		this.searching = true;
		this.purchaseorders = this.globalSearchService.filterItem(this.openOrderData, search, 'orderno,supplierno,deliverydate,itemcode,itemdescription,requisitionno');
		this.searching = false;
	}

	announceSortChange(event: any) {

	}

	viewOrder(orderno: any, content: any) {
		this.purchasingService.getRga(orderno).subscribe((order: any) => {
			this.podetails = order
			this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
		});
	}


	back(): void {
		this.location.back()
	}

	ngOnChanges(changes: any) {
		if (changes) {
			const search = {
				item: this.item,
				vendor: this.vendor,
			}

			this.purchasingService.searchRgas(search).subscribe((results: any) => {
				this.allpurchaseorders = results;
				this.po_data.emit(results);
				this.statuses = results.statuses
				this.setTableData(results.pos)
			});
		}
	}
	ngAfterViewInit() {
		//this.customers.sort = this.sort;
		//this.customers.paginator = this.paginator;
	}

}
